import React from 'react'
import { BANKING_BOTTOM_CONTENT, DESIGN_COURSE_PAGE_3, DESIGN_DETAILS_PAGE_3, DESIGN_HERO_PAGE_3 } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import { DESIGN_ACCORDIAN_3 } from '../../../utils/courseConifg'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'

const DesignPage_3 = () => {
  return (
    <div className='outlet-render'>
    <CourseAsideHero  {...DESIGN_HERO_PAGE_3}/>
     <CoursesAside {...DESIGN_COURSE_PAGE_3}/>
     <CourseCard {...DESIGN_DETAILS_PAGE_3}/>
     <Accordian {...DESIGN_ACCORDIAN_3}/>
     <PageDesc {...BANKING_BOTTOM_CONTENT}/>
   </div>
  )
}

export default DesignPage_3